/* This is a fake infinite scroll component for displaying list / grid of items, one chunk at the
 * time.
 *
 * It is FAKE because it loads all data at once - and only displays it in chunks. Creating proper
 * infinite scroll means modifying gatsby-node and enabling requests for chunked data.
 */

import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { isEqual } from 'lodash-es';

const InfiniteRoll = ({ items, children, chunkSize, treshold, loader }) => {
  const [itemsState, setItemsState] = useState({
    originalItems: items,
    itemsRest: items.slice(chunkSize),
    itemsChunked: items.slice(0, chunkSize)
  });

  const loadItems = () => {
    const itemsAllCopy = [...itemsState.itemsRest];
    const chunk = itemsAllCopy.splice(0, chunkSize);
    setItemsState({
      ...itemsState,
      itemsChunked: [...itemsState.itemsChunked, ...chunk],
      itemsRest: itemsAllCopy
    });
  };

  useEffect(() => {
    const oldI = itemsState.originalItems.map(p => p.id).sort();
    const newI = items.map(p => p.id).sort();
    if (!isEqual(oldI, newI)) {
      setItemsState({
        originalItems: items,
        itemsRest: items.slice(chunkSize),
        itemsChunked: items.slice(0, chunkSize)
      });
    }
  });

  return (
    <InfiniteScroll
      threshold={treshold}
      pageStart={0}
      loader={loader || <div key="loader"/>}
      loadMore={() => {
        loadItems();
      }}
      hasMore={!!itemsState.itemsRest.length}
    >
      {children(itemsState.itemsChunked)}
    </InfiniteScroll>
  );
};

export default InfiniteRoll;

InfiniteRoll.defaultProps = {
  chunkSize: 6,
  treshold: 250,
  loader: null,
  items: []
};
